<template>
    <div id="Account_DashBoard">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template>
                <div class="page-name">
                    <span class="page-title" id="dashboard">Work Queue</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dashboard-page">
                        <section class="internal-container border-top-table-fl">
                            <!-- Payment with Follow Up Date-->
                            <template>
                                <div class="reservation-dashboard-section">
                                    <div class="dashboard-btm-section">
                                        <h5 id="mydesc" class="color-darkblue font-semibold"> Payment </h5>
                                        <div class="dashboard-module-btm-section basic-form-container">
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-sm font-1">
                                                    <thead>
                                                        <tr class="table-header">
                                                            <th>Status</th>
                                                            <th>Sequence</th>
                                                            <th>#Account</th>
                                                            <th>Account Name</th>
                                                            <th>#Payment</th>
                                                            <th>Amount</th>
                                                            <th>Date</th>
                                                            <th>Description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="paymentArr && paymentArr.length > 0">
                                                            <tr v-for="(pay, payindex) in paymentArr" v-bind:key="payindex">
                                                                <td>{{ pay.status }}</td>
                                                                <td>{{ pay.id }}</td>
                                                                <td>{{ pay.account_number }}</td>
                                                                <td>{{ pay.account_name }}</td>
                                                                <td>{{ pay.payment_no }}</td>
                                                                <td>{{ pay.amount }}</td>
                                                                <td>{{ pay.date }}</td>
                                                                <td>{{ pay.description }}</td>
                                                            </tr>
                                                        </template>
                                                        <template v-else>
                                                            <tr>
                                                                <td class="no-data-found" style="text-align:center" colspan="11">{{"No Data Found!"}}</td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="btn-groups text-right">
                                            <button type="submit" id="CreateCustomerBtn" class="btn btn-primary" v-on:click.prevent="viewAllPaymentDetail()" > <i class="fp-view"></i> View all
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
    name: "DashBoard",
    mixins:[commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: true,
        loading:false,
        serverParams: {
            columnFilters: {},
            sort: {
                field: "follow_up_date",
                type: "asc"
            },
            page: 1,
            perPage: 5
        },
        paymentArr:[]
    }),
    watch:{

    },
    created: function() {

    },
    mounted: function() {
        
            var self = this;
            self.listPaymentDetail();
    },
    methods: {

        viewAllPaymentDetail() {
            var self = this;
            self.$router.push({ name: 'BankTransferList', query: { from: "account-dashboard" }});
        },

        listPaymentDetail() {
            var self = this;
            //call api only if user have permission to access the list
            
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: 10,
                filters: self.serverParams.columnFilters,
                sort: {
                    field: "id",
                    type: "desc"
                },
                flag: "dashboard",
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/bank-transfer/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        self.paymentArr = data.content.row;
                        // self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                }
            });
            
        },

    }
};
</script>




// WEBPACK FOOTER //
// src/components/AccountDashboard.vue